import React from 'react';

import heartIcon from '../../../../Icons/icon-heart.svg';
import { socialMediaObjects } from './Data';

export function Footer() {
  return (
    <div className="footer ">
      <div className="crafted flex justify-center items-center bg-161616 font-manrope text-white opacity-60 text-base leading-5 tracking-normal font-semibold m-auto py-5">
        Crafted with
        <img src={heartIcon} className="mx-1" alt="" />
        in India
      </div>
      <div className="connect-social-media-container py-9">
        <div className="text-container flex justify-center font-manrope text-sm font-light text-white opacity-60 tracking-wider">
          Connect with us
        </div>
        <div className="social-media-container flex justify-center items-center mt-3 mb-10 mobile:pb-20 pb-28">
          {socialMediaObjects.map((object) => {
            return (
              <a
                href={object.url}
                target="_blank"
                key={object.url}
                rel="noreferrer"
              >
                <div className="round-container w-12 h-12 rounded-full bg-161616 flex justify-center items-center mx-2 mobile:mx-1">
                  <img src={object.icon} className="h-6" alt="" />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}
